/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import defaultImg from '@/resources/images/mall/b.jpg';
import ImgItem from '@/components/ImgItem';
export default {
  props: {
    itemObj: {
      type: Object,
      "default": function _default() {
        return {
          hot: true
        };
      }
    },
    priceShow: {
      type: String,
      "default": 'right'
    }
  },
  components: {
    ImgItem: ImgItem
  },
  computed: {},
  data: function data() {
    return {
      testImg: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=1626039801,2689375718&fm=27&gp=0.jpg',
      defaultImg: defaultImg
    };
  },
  created: function created() {},
  methods: {
    radioDone: function radioDone() {}
  }
};